import { render, staticRenderFns } from "./Navigation.vue?vue&type=template&id=014bd476&scoped=true&"
import script from "./Navigation.vue?vue&type=script&lang=js&"
export * from "./Navigation.vue?vue&type=script&lang=js&"
import style0 from "./Navigation.vue?vue&type=style&index=0&id=014bd476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../data/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014bd476",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014bd476')) {
      api.createRecord('014bd476', component.options)
    } else {
      api.reload('014bd476', component.options)
    }
    module.hot.accept("./Navigation.vue?vue&type=template&id=014bd476&scoped=true&", function () {
      api.rerender('014bd476', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "@shared/Charts/Layouts/components/Navigation.vue"
export default component.exports